module.exports = __webpack_public_path__ + "media/images/xpass/markers/active/stretchlab-6a357a9b884854f69fd0193a0c468451.png";